import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import axiosInstance from "../../../Config/axiosInstance";
import "./OpportunityActionHistory.css";

const formatDateTimeRO = (dateString) => {
  if (!dateString) return "-";

  try {
    const date = new Date(dateString);
    return date.toLocaleString("ro-RO", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (error) {
    console.error("Eroare la formatarea datei:", error);
    return dateString;
  }
};

const OpportunityHistoryDialog = ({ open, onClose, opportunity }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !opportunity?.id) return;

    const loadHistory = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(
          `/opportunity-action-history/?opportunity=${opportunity.id}`
        );
        setHistory(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error(
          "Eroare la încărcarea istoricului:",
          error.response ? error.response.data : error
        );
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };

    loadHistory();
  }, [open, opportunity]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      className="opportunity-history-dialog"
    >
      <DialogTitle>
        Opportunity Action History
        {opportunity?.title_opportunity
          ? ` - ${opportunity.title_opportunity}`
          : ""}
      </DialogTitle>

      <DialogContent dividers className="opportunity-history-content">
        {loading ? (
          <Box className="opportunity-history-loading">
            <CircularProgress />
          </Box>
        ) : history.length === 0 ? (
          <Box className="opportunity-history-empty">
            <Typography>Niciun istoric disponibil.</Typography>
          </Box>
        ) : (
          <Box className="opportunity-history-list">
            {history.map((item, index) => (
              <Box className="opportunity-history-card" key={item.id || index}>
                <Typography className="opportunity-history-title">
                  {item.action_text || "-"}
                </Typography>

                <Box className="opportunity-history-grid">
                  <Box className="opportunity-history-field">
                    <span className="opportunity-history-label">
                      Action Code
                    </span>
                    <div className="opportunity-history-value">
                      <span className="opportunity-history-code-badge">
                        {item.action_code_label || item.action_code || "-"}
                      </span>
                    </div>
                  </Box>

                  <Box className="opportunity-history-field">
                    <span className="opportunity-history-label">
                      Date
                    </span>
                    <div className="opportunity-history-value">
                      {formatDateTimeRO(item.action_date)}
                    </div>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>

      <DialogActions className="opportunity-history-footer">
        <Button
          onClick={onClose}
          variant="contained"
          className="opportunity-history-close-btn"
        >
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OpportunityHistoryDialog;